module.exports = __webpack_public_path__ + "static/media/1.969f0fb2.png";